import { render, staticRenderFns } from "./qa-info-audit.vue?vue&type=template&id=94aa0a1a&scoped=true&"
import script from "./qa-info-audit.vue?vue&type=script&lang=js&"
export * from "./qa-info-audit.vue?vue&type=script&lang=js&"
import style0 from "./qa-info-audit.vue?vue&type=style&index=0&id=94aa0a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aa0a1a",
  null
  
)

export default component.exports